// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"123":"case","187":"search"}[chunkId] + "." + {"123":"1913b7f3bf0b40d342db","187":"98181e84bbe2bb4e7c9e"}[chunkId] + ".bundle.css";
};